export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/pavel-kosov-28fffe0407dbdac08a0433893c4639c5.jpg";